import '../scss/main.scss'
import bootstrapApplication from './main'
// bootstrap the application with $(document).ready() shorthand

jQuery(bootstrapApplication)



// WEBPACK FOOTER //
// ./src/js/app.js